import { authorizationHeader, responseBody } from "util/fetchUtil";
import { TokenManager } from "util/TokenManager";

// const host = "https://portolaprod.azurewebsites.net";
const host = "https://portolaprod.azurewebsites.net";

export const loadPrimaryContact = async () => {
    try {
        const url = `${host}/api/users/?is_active=true`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: authorizationHeader(TokenManager.getToken()),
            },
        });
        const responseAsJSON = await responseBody(response);
        return responseAsJSON;
    } catch (err) {
        throw err;
    }
};

export const loadDocumentApprover = async (customerIds) => {
    try {
        // Build the query like ?ids=505,613
        const query = customerIds && customerIds.length > 0 ? `?ids=${customerIds.join(",")}` : "";

        const url = `${host}/api/entities/get_users/${query}`;

        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: authorizationHeader(TokenManager.getToken()),
            },
        });

        const responseAsJSON = await responseBody(response);
        return responseAsJSON;
    } catch (err) {
        throw err;
    }
};



export const loadPvelManager = async () => {
    try {
        const url = `${host}/api/users/?is_staff=true`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: authorizationHeader(TokenManager.getToken()),
            },
        });
        const responseAsJSON = await responseBody(response);
        return responseAsJSON;



    } catch (err) {
        throw err;
    }
};

export const loadCustomer = async () => {
    try {
        const url = `${host}/api/entities/?limit=-1`;;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: authorizationHeader(TokenManager.getToken()),
            },
        });
        const responseAsJSON = await responseBody(response);
        return responseAsJSON.results;
    } catch (err) {
        throw err;
    }
};
export const loadProjectTemplate = async () => {
    try {
        const url = `${host}/api/project_template/?limit=-1`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: authorizationHeader(TokenManager.getToken()),
            },
        });
        const responseAsJSON = await responseBody(response);
        return responseAsJSON;
    } catch (err) {
        throw err;
    }
};


export const fetchTemplateDetails = async (templateUrl) => {
    try {
        const response = await fetch(templateUrl, {
            method: "GET",
            headers: {
                Authorization: authorizationHeader(TokenManager.getToken()),
            },
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch template details: ${response.statusText}`);
        }

        const responseAsJSON = await responseBody(response);
        return responseAsJSON;
    } catch (err) {
        console.error("Error in fetchTemplateDetails:", err);
        throw err;
    }
};

export const createProject = async (formData) => {
    const response = await fetch(`${host}/api/projects/`, {
        method: "POST",
        headers: {
            Authorization: authorizationHeader(TokenManager.getToken()),
        },
        body: formData,
    });
    return response;
};

export const createTemplate = async (formData) => {
    const response = await fetch(`${host}/api/project_template/`, {
        method: "POST",
        headers: {
            Authorization: authorizationHeader(TokenManager.getToken()),
        },
        body: formData,
    });
    return response;
};

export const updateTemplate = async (formData, id) => {
    const response = await fetch(`${host}/api/project_template/${id}/`, {
        method: "PUT",
        headers: {
            Authorization: authorizationHeader(TokenManager.getToken()),
        },
        body: formData,
    });
    return response;
};

export const loadEnitiesTemplate = async () => {
    try {
        const url = `${host}/api/entity_template/?limit=-1`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: authorizationHeader(TokenManager.getToken()),
            },
        });
        const responseAsJSON = await responseBody(response);
        return responseAsJSON;
    } catch (err) {
        throw err;
    }
};

export const loadCompaniesList = async () => {
    try {
        const url = `${host}/api/companies/?limit=-1`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: authorizationHeader(TokenManager.getToken()),
            },
        });
        const responseAsJSON = await responseBody(response);
        return responseAsJSON;
    } catch (err) {
        throw err;
    }
};

export const loadDownstreamPartners = async () => {
    try {
        const url = `${host}/api/entities/?limit=-1`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: authorizationHeader(TokenManager.getToken()),
            },
        });
        const partnersResponseAsJSON = await responseBody(response);
        return partnersResponseAsJSON;
    } catch (err) {
        throw err;
    }
};

export const loadActiveProjects = async (EntityId) => {
    try {
        const url = `${host}/api/projects/get_projects/?entity_id=${EntityId}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: authorizationHeader(TokenManager.getToken()),
            },
        });
        const responseAsJSON = await responseBody(response);
        return responseAsJSON;
    } catch (err) {
        throw err;
    }
};



// export const getActiveProjects = async (page, limit) => {
//   const offset = page * limit; 
//   const url = `${host}/api/projects/?limit=${limit}&offset=${offset}&status=ACTIVE`;
//   const response = await fetch(url, {
//     headers: { Authorization: authorizationHeader(TokenManager.getToken()) },
//   });
//   return response.json();
// };

export const getActiveProjects = async (page, limit, filters = {}) => {
    const offset = page * limit;

    try {
        let url = `${host}/api/projects/?limit=${limit}&offset=${offset}&status=ACTIVE`;

        // Safe filter (no empty string, no whitespace)
        if (filters.projectNumber ) {
            url += `&number=${filters.projectNumber.trim()}`;
        }

        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: authorizationHeader(TokenManager.getToken()),
            },
        });

        const responseAsJSON = await responseBody(response);
        return responseAsJSON;

    } catch (err) {
        throw err;
    }
};


export const getProjectById = async (id) => {

    const url = `${host}/api/projects/${id}/`;
    const response = await fetch(url, {
        headers: { Authorization: authorizationHeader(TokenManager.getToken()) },
    });
    return response.json();
};


export const updateProject = async (formData) => {
    const response = await fetch(`${host}/api/projects/update_project_details/`, {
        method: "POST",
        headers: {
            Authorization: authorizationHeader(TokenManager.getToken()),
        },
        body: formData,
    });
    return response;
};





export const loadTechnologyTags = async () => {
    try {
        const url = `${host}/api/tags/?limit=-1`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: authorizationHeader(TokenManager.getToken()),
            },
        });
        const responseAsJSON = await responseBody(response);
        return responseAsJSON;
    } catch (err) {
        throw err;
    }
};

export const loadDocumentsTemplate = async () => {
    try {
        const url = `${host}/api/document_template/?limit=-1`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: authorizationHeader(TokenManager.getToken()),
            },
        });
        const responseAsJSON = await responseBody(response);
        return responseAsJSON;
    } catch (err) {
        throw err;
    }
};


// export const loadEntityGet = async (page, limit) => {
//     const offset = page * limit; 

//     try {
//         const url = `${host}/api/entities/?limit=${limit}&offset=${offset}`;
//         const response = await fetch(url, {
//             method: "GET",
//             headers: {
//                 Authorization: authorizationHeader(TokenManager.getToken()),
//             },
//         });
//         const responseAsJSON = await responseBody(response);
//         return responseAsJSON;
//     } catch (err) {
//         throw err;
//     }
// };

export const loadEntityGet = async (page, limit, filters = {}) => {
    const offset = page * limit;

    try {
        let url = `${host}/api/entities/?limit=${limit}&offset=${offset}`;


        if (filters.companyName) {
            url += `&display_name=${filters.companyName}`;
        }


        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: authorizationHeader(TokenManager.getToken()),
            },
        });

        const responseAsJSON = await responseBody(response);
        return responseAsJSON;

    } catch (err) {
        throw err;
    }
};


export const getEntityById = async (id) => {

    const url = `${host}/api/entities/${id}/`;
    const response = await fetch(url, {
        headers: { Authorization: authorizationHeader(TokenManager.getToken()) },
    });
    return response.json();
};

export const updateEntity = async (formData) => {
    const response = await fetch(`${host}/api/entities/update_entity_details/`, {
        method: "POST",
        headers: {
            Authorization: authorizationHeader(TokenManager.getToken()),
        },
        body: formData,
    });
    return response;
};

// edit document

export const loadDocumentGet = async (page, limit,filters={}) => {
    const offset = page * limit;
    try {
        let url = `${host}/api/documents/?limit=${limit}&offset=${offset}`;

        if (filters.projectNumber) {
            url += `&project__number=${filters.projectNumber}`;
        }
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: authorizationHeader(TokenManager.getToken()),
            },
        });
        const responseAsJSON = await responseBody(response);
        return responseAsJSON;
    } catch (err) {
        throw err;
    }
};

export const getDocumentById = async (id) => {

    const url = `${host}/api/documents/${id}/`;
    const response = await fetch(url, {
        headers: { Authorization: authorizationHeader(TokenManager.getToken()) },
    });
    return response.json();
};


export const updateDocuments = async (formData) => {
    const response = await fetch(`${host}/api/documents/update_document_details/`, {
        method: "POST",
        headers: {
            Authorization: authorizationHeader(TokenManager.getToken()),
        },
        body: formData,
    });
    return response;
};